import cisFertigationDataConfig from '@/api/config/cisFertigationDataConfig'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { getApiErrorMessage } from '@/helpers'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function deleteFertigation(id: string): Promise<void> {
  await cisFertigationDataConfig.delete(id)
}

function useDeleteCisFertigation() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeModal } = useConfigUI()

  return useMutation(
    (payload: { id: string }) => deleteFertigation(payload.id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.cisFertigation])
        toast.success(t('deleteFertigationSuccess'))
        closeModal()
      },
      onError: (error: any) => {
        // Any refusal the server explains (400 and 403 alike) is shown as it
        // came; the generic text is only for an error that carries none.
        toast.error(getApiErrorMessage(error, t('deleteFertigationError')))
      },
    },
  )
}

export default useDeleteCisFertigation
